import type { Note, NoteEntityType } from '@carboncopyco/types';
import { mainApi } from './mainApi';

type GetNotesArgs = {
  organizationId: string;
  entityType: NoteEntityType;
  entityId: string;
};

type GetNotesResponse = Note[];

type CreateNoteArgs = {
  organizationId: string;
  entityType: NoteEntityType;
  entityId: string;
  content: string;
};

type UpdateNoteArgs = {
  organizationId: string;
  noteId: string;
  content: string;
};

export const notesApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotes: builder.query<GetNotesResponse, GetNotesArgs>({
      query: ({ organizationId, entityType, entityId }) => ({
        url: `/api/${organizationId}/note/${entityType}/${entityId}`,
        method: 'GET',
      }),
      providesTags: (_, __, { entityId }) => [{ type: 'Notes', id: entityId }],
    }),
    createNote: builder.mutation<Note, CreateNoteArgs>({
      query: ({ organizationId, entityType, entityId, content }) => ({
        url: `/api/${organizationId}/note/${entityType}/${entityId}`,
        method: 'POST',
        body: { content },
      }),
      invalidatesTags: (_, __, { entityId }) => [
        { type: 'Notes', id: entityId },
      ],
    }),
    updateNote: builder.mutation<Note, UpdateNoteArgs>({
      query: ({ organizationId, noteId, content }) => ({
        url: `/api/${organizationId}/note/${noteId}`,
        method: 'PUT',
        body: { content },
      }),
      invalidatesTags: ['Notes'],
    }),
  }),
});

export const {
  useGetNotesQuery,
  useLazyGetNotesQuery,
  useCreateNoteMutation,
  useUpdateNoteMutation,
} = notesApi;
